import React, { useEffect, useState } from 'react';
import { Dialog, T } from '@colonist/ui';
import { TextInput, TextValidationWrapper } from '@colonist/ui-platform';
import { MAX_ROOM_ID_LENGTH } from '@colonist/consts';
import styles from './JoinRoomDialog.module.scss';
/** Dialog prompting the user for a room ID to join. */ export const JoinRoomDialog = ({ open, onClose, onJoin })=>{
    const [roomId, setRoomId] = useState('');
    const normalizedRoomId = roomId.trim().toLocaleLowerCase();
    const canJoin = normalizedRoomId.length > 0;
    useEffect(()=>{
        if (!open) setRoomId('');
    }, [
        open
    ]);
    const handleJoin = ()=>{
        if (!canJoin) return;
        onJoin(normalizedRoomId);
        onClose();
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        handleJoin();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.lobbyPage.popups.enterRoomID.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.lobbyPage.popups.enterRoomID.body'
        }
    })), /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(TextValidationWrapper, {
        maxLength: MAX_ROOM_ID_LENGTH
    }, ({ maxLength: wrapperMaxLength, onChange: wrapperOnChange, ref: wrapperRef })=>/*#__PURE__*/ React.createElement(TextInput, {
            ref: wrapperRef,
            value: roomId,
            onChange: (event)=>{
                wrapperOnChange(event);
                setRoomId(event.target.value);
            },
            maxLength: wrapperMaxLength,
            autoFocus: true,
            autoComplete: "off"
        })))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: onClose
    }), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        disabled: !canJoin,
        onClick: handleJoin
    })));
};
